<div class="card card-box">
    <div class="card-header">
        <div class="display-5  card-header--title font-weight-bold" style="font-size: 16px;">
            Monthly Invoice Reports
        </div>
        <div class="card-header--actions">
            <div class="btn-group btn-group-sm" dropdown placement="bottom right">
                <button class="btn btn-sm dropdown-toggle no-caret btn-neutral-primary" (click)="showFilter()"
                        dropdownToggle type="button">
                    <span class="btn-wrapper--label">Filters</span>
                    <span class="btn-wrapper--icon">
                        <fa-icon *ngIf="!isShow" [icon]="['fas', 'chevron-down']" class="opacity-8 font-size-xs ml-1">
                        </fa-icon>
                        <fa-icon *ngIf="isShow" [icon]="['fas', 'chevron-up']" class="opacity-8 font-size-xs ml-1">
                        </fa-icon>
                    </span>
                </button>
            </div>
            <button (click)="exportExcel()" tooltip="Excel" id="excelBtn"
                    class="btn d-32 p-0 btn-animated-icon btn-animated-icon--primary btn-neutral-primary ml-2"
                    type="button">
                <fa-icon [icon]="['far', 'file-excel']" class="h5 d-block mb-2 mt-1 text-primary btn-wrapper--icon">
                </fa-icon>
            </button>
            <div class="btn-group btn-group-sm" dropdown placement="bottom right">
                <button tooltip="Refresh" (click)="onReset()"
                        class="btn d-32 p-0 btn-animated-icon btn-animated-icon--primary btn-neutral-primary ml-2"
                        type="button">
                    <span class="btn-wrapper--icon">
                        <i class="ion-md-sync"></i>
                    </span>
                </button>
            </div>
        </div>
    </div>

    <div class="card-body">
        <div>
            <div class=" justify-content-between">
                <div *ngIf="isShow">
                    <form [formGroup]="filters_form" novalidate>
                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label> Reservation Type</label>
                                    <ng-select formControlName="resType">
                                        <div *ngFor="let contract of contracts">
                                            <ng-option value="{{contract.contractId}}">
                                                {{ contract.contractId }}
                                            </ng-option>
                                        </div>
                                    </ng-select>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>Reservation From Date</label>
                                    <div class="input-group input-group-lg">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">
                                                <fa-icon [icon]="['far', 'calendar-alt']" class="mx-auto">
                                                </fa-icon>
                                            </span>
                                        </div>
                                        <input [bsConfig]="{
                                containerClass: 'theme-primary',
                                isAnimated: true,
                                customTodayClass: 'custom-today-class'
                              }" bsDatepicker formControlName="startDate" class="form-control"
                                               placeholder="Select date" type="text"/>
                                    </div>
                                </div>
                            </div>
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label>Reservation To Date</label>
                                    <div class="input-group input-group-lg">
                                        <div class="input-group-prepend">
                                            <span class="input-group-text">
                                                <fa-icon [icon]="['far', 'calendar-alt']" class="mx-auto">
                                                </fa-icon>
                                            </span>
                                        </div>
                                        <input [bsConfig]="{
                                containerClass: 'theme-primary',
                                isAnimated: true,
                                customTodayClass: 'custom-today-class'
                              }" bsDatepicker formControlName="endDate" class="form-control" placeholder="Select date"
                                               type="text"/>
                                    </div>
                                </div>
                            </div>
                            <!--<div class="col-md-3">
                                <div class="form-group">
                                    <label> Stations</label>
                                    <ng-select [multiple]="true" formControlName="stationcodes">
                                        <div *ngFor="let station of stations">
                                            <ng-option [value]="station.stationid">
                                                {{ station?.stationid }} - {{ station?.airportName }}
                                            </ng-option>
                                        </div>
                                    </ng-select>
                                </div>
                            </div>-->
                        </div>
                        <div class="row">
                            <div class="col-md-3">
                                <div class="form-group">
                                    <label> Reservation Status</label>
                                    <ng-select formControlName="resStatusIds" [multiple]="true">
                                        <div *ngFor="let resStatus of reservationStatusList">
                                            <ng-option [value]="resStatus.resStatusId">
                                                {{ resStatus.resBoText }}
                                            </ng-option>
                                        </div>
                                    </ng-select>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group pt-4">
                                    <button class="btn  mt-2 btn-sm btn-block btn-primary btn-square" type="button"
                                            (click)="onFilter(filters_form.value)">
                                        Search
                                    </button>
                                </div>
                            </div>
                            <div class="col-md-2">
                                <div class="form-group pt-4">
                                    <button class="btn btn-sm mt-2  btn-block btn-primary btn-square" type="button"
                                            (click)="onReset()">
                                        Clear
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
                <div class="card shadow-sm mt-4 mb-2" *ngIf="monthlyInvoice.bookingBreakdown.length > 0">
                    <div class="card-header bg-primary text-white ">
                        <h5 class="mb-0">Reservations Summary</h5>
                    </div>
                    <div class="card-body">
                        <table class="table table-bordered table-striped">
                            <tbody>
                            <tr>
                                <th>Total no. of bookings (with cancellations):</th>
                                <td>{{ monthlyInvoice.summary.totalOfBookingsWithCancellations }}</td>
                            </tr>
                            <tr>
                                <th>Total no. of bookings executed (charged)</th>
                                <td>{{ monthlyInvoice.summary.totalBookingsExecutedCharged }}</td>
                            </tr>
                            <tr>
                                <th>Total no. of bookings cancelled with charge (charged)</th>
                                <td>{{ monthlyInvoice.summary.totalCancelledBookingsCharged }}</td>
                            </tr>
                            <tr>
                                <th>Total no. of bookings cancelled/comp (no charge)</th>
                                <td>{{ monthlyInvoice.summary.totalCancelledComp }}</td>
                            </tr>
                            <tr>
                                <th>Total expense {{ filters_form.value.resType }}</th>
                                <td>{{ monthlyInvoice.summary.totalExpense | currency:'USD' }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="card card-box mt-4 mb-4" *ngIf="monthlyInvoice.bookingBreakdown.length > 0">
                    <div class="card-header">
                        <h5 class="mb-0">Destinations:</h5>
                    </div>
                    <div class="card-body p-0">
                        <table class="table table-bordered table-sm mb-0">
                            <thead class="thead-dark">
                            <tr>
                                <th>Airport</th>
                                <th *ngFor="let dest of monthlyInvoice.destinations">{{ dest.code }}</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr>
                                <td>Total No. of bookings</td>
                                <td *ngFor="let dest of monthlyInvoice.destinations">{{ dest.metrics.bookings }}</td>
                            </tr>
                            <tr>
                                <td>Total No. of passengers</td>
                                <td *ngFor="let dest of monthlyInvoice.destinations">{{ dest.metrics.passengers }}</td>
                            </tr>
                            <tr>
                                <td>Total No. of Arrival Service</td>
                                <td *ngFor="let dest of monthlyInvoice.destinations">{{ dest.metrics.arrivalService }}</td>
                            </tr>
                            <tr>
                                <td>Total No. of Departure Service</td>
                                <td *ngFor="let dest of monthlyInvoice.destinations">{{ dest.metrics.departureService }}</td>
                            </tr>
                            <tr>
                                <td>Total No. of Transfer Service</td>
                                <td *ngFor="let dest of monthlyInvoice.destinations">{{ dest.metrics.transferService }}</td>
                            </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
                <div class="d-flex justify-content-between pb-3">
                    <div class="search-wrapper">
                        <span class="icon-wrapper text-black">
                            <fa-icon [icon]="['fas', 'search']"></fa-icon>
                        </span>
                        <input type="text" class="form-control form-control-sm rounded-pill"
                               placeholder="ResID" [ngModelOptions]="{ standalone: true }"
                               [(ngModel)]="searchText"/>
                    </div>
                </div>
                <div *ngIf="monthlyInvoice.bookingBreakdown | tsearch: searchText; let filtereddayBeforeData">
                    <div class="table-responsive table-scroll">
                        <table id="report25con" class="table table-hover table-striped table-bordered text-nowrap mb-3"
                               [mfData]="filtereddayBeforeData" #mf="mfDataTable" [mfRowsOnPage]="100">
                            <thead>
                            <tr>
                                <th class="bg-white text-left">Res ID</th>
                                <th class="bg-white text-left">Res Type</th>
                                <th class="bg-white text-left">Direction</th>
                                <th class="bg-white text-left">Start Date</th>
                                <th class="bg-white text-left">Airport</th>
                                <th class="bg-white text-left">Num Pax</th>
                                <th class="bg-white text-left">Passenger's Last Name (First 3 Letters)</th>
                                <th class="bg-white text-left">Total Service Amount</th>
                                <th class="bg-white text-left">Additional Services</th>
                                <th class="bg-white text-left">Cancellation Fee</th>
                                <th class="bg-white text-left">Total Cost</th>
                                <th class="bg-white text-left">Additional Notes</th>
                            </tr>
                            </thead>
                            <tbody>
                            <tr *ngFor="let reservation of mf.data; let i = index;">
                                <td class="text-left">{{ reservation.ResID }}</td>
                                <td class="text-left">{{ reservation.RES_TYPE }}</td>
                                <td class="text-left">
                                    <span *ngIf="reservation.ServiceDirectionID === 'A'">Arrival</span>
                                    <span *ngIf="reservation.ServiceDirectionID === 'D'">Departure</span>
                                    <span *ngIf="reservation.ServiceDirectionID === 'X'">Transfer</span>
                                </td>
                                <td class="text-left">{{ dateTranfor(reservation.StartDT) }}</td>
                                <td class="text-left">{{ reservation.AirportIATA }}</td>
                                <td class="text-left">{{ reservation.NumPax }}</td>
                                <td class="text-left">{{ reservation.PassengerCode }}</td>
                                <td class="text-left">{{ reservation.TotalServiceLineAmount  }}</td>
                                <td class="text-left">{{ reservation.AdditionalServicesAmount }}</td>
                                <td class="text-left">{{ reservation.CancellationFeeAmount  }}</td>
                                <td class="text-left">{{ reservation.TotalCost || 0 }}</td>
                                <td class="text-left">{{ reservation.AdditionalNotes }}</td>
                            </tr>
                            </tbody>
                            <tfoot>
                            <tr>
                                <td colspan="25">
                                        <span class="font-weight-bold">Total Records: {{
                                                filtereddayBeforeData.length
                                            }}</span> &nbsp;&nbsp;&nbsp;
                                    <mfBootstrapPaginator [rowsOnPageSet]="[100, 200, 300]">
                                    </mfBootstrapPaginator>
                                </td>
                            </tr>
                            </tfoot>
                        </table>
                    </div>
                </div>
            </div>
        </div>

    </div>
</div>

<ngx-spinner [fullScreen]="false" size="medium" type="ball-spin-clockwise"></ngx-spinner>
